import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@core-engine/config/types.js'
import { safeWriteFile } from '@core-engine/utils/fs.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace.js'
import { readTemplate } from '@next-adapter/template-reader.js'

export interface DatabaseScaffoldOptions {
  cwd: string
  config: ResolvedBetterstartConfig
}

export function scaffoldDatabase({ cwd, config }: DatabaseScaffoldOptions): string[] {
  const created: string[] = []
  const dbDir = path.resolve(cwd, config.paths.admin, 'lib', 'db')
  const namespace = config.frameworkConfig.next.namespace

  function write(filename: string, content: string): void {
    const fullPath = path.join(dbDir, filename)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(content, namespace))) {
      created.push(path.join(config.paths.admin, 'lib', 'db', filename))
    }
  }

  write('client.ts', readTemplate('lib/db/client.ts'))
  write('core/schema.ts', readTemplate('lib/db/core/schema.ts'))
  write('schema.ts', readTemplate('lib/db/schema.ts'))

  // Drizzle config goes at project root (where drizzle-kit expects it)
  const drizzleConfigPath = path.resolve(cwd, 'drizzle.config.ts')
  if (
    safeWriteFile(
      drizzleConfigPath,
      applyAdminNamespaceToContent(readTemplate('drizzle.config.ts'), namespace)
    )
  ) {
    created.push('drizzle.config.ts')
  }

  return created
}
